import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const WorkflowTriggerUser = React.lazy(() =>
    import('../WorkflowTriggerUser')
);
const workflowTriggerUserRoutesRegistry = [
    {
        path: PAGE_URL.WORKFLOW_TRIGGER_USER_PAGE,
        element: <WorkflowTriggerUser />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default workflowTriggerUserRoutesRegistry;
